import { create } from "zustand";
import { MAIN_URL } from "../../Configurations/Urls";
import axios from "axios";

const useEmployeeDataStore = create((set, get) => ({
  Employee: {
    employee_code: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    date_of_birth: "",
    employee_id: "",
    organization_id: "",
    gender: "",
    marital_status: "",
    disability_flag: 0,
    profile_image_url: "",
    organization_unit_id: "",
    organization_employment_type_id: "",
    organization_department_id: "",
    organization_designation_id: "",
    organization_employment_type_id: "",
    organization_work_model_id: "",
    organization_work_shift_id: "",
    organization_employment_status_id: "",
    organization_user_id: "",
    date_of_joining: "",
    organization_user_id: "",
    reporting_manager_id: "",
  },
  EmployeeErrors: {},
  setEmployeeErrors: (data) => set({ EmployeeErrors: data }),
  setEmployee: (data) => set({ Employee: data }),
  setEducation: (data) => set({ Education: data }),
  setAddress: (data) => set({ Address: data }),
  setContact: (data) => set({ Contact: data }),
  setEmployeeData: (data) =>
    set((state) => {
      const updatedErrors = { ...state.EmployeeErrors };

      // Clear error for the field being updated
      Object.keys(data).forEach((key) => {
        if (updatedErrors[key]) {
          delete updatedErrors[key];
        }
      });

      return {
        Employee: { ...state.Employee, ...data },
        EmployeeErrors: updatedErrors,
      };
    }),

  Education: [
    {
      organization_education_level_id: "",
      organization_education_degree_id: "",
      organization_education_stream_id: "",
      institute_name: "",
      board_university_name: "",
      marks_percentage: "",
      year_of_passing: "",
      is_pursuing: "",
      employee_id: "",
      organization_id: "",
    },
  ],
  EducationErrors: {},
  AddressErrors: {},
  ContactErrors: {},
  setEducationErrors: (data) => set({ EducationErrors: data }),
  setAddressErrors: (data) => set({ AddressErrors: data }),
  setContactErrors: (data) => set({ ContactErrors: data }),
  setEducationData: (name, value, id) => {
    const { Education, EducationErrors } = get();

    // Update education data
    const updatedEducation = [...Education];
    updatedEducation[id] = {
      ...updatedEducation[id],
      [name]: value,
    };

    // Clear error for that field if it exists
    const updatedErrors = { ...EducationErrors };
    if (updatedErrors[id] && updatedErrors[id][name]) {
      delete updatedErrors[id][name];

      // If that index has no more errors, remove the whole object
      if (Object.keys(updatedErrors[id]).length === 0) {
        delete updatedErrors[id];
      }
    }

    // Update both state slices
    set({
      Education: updatedEducation,
      EducationErrors: updatedErrors,
    });
  },

  Language: [
    {
      employee_id: "",
      language_id: "",
      can_read: false,
      can_write: false,
      can_speak: false,
      is_native: false,
      description: "",
      organization_id: "",
    },
  ],
  Family: [
    {
      employee_id: "",
      name: "",
      relationship: "",
      phone: "",
      date_of_birth: "",
      is_dependent: "",
      organization_id: "",
    },
  ],
  Address: [
    {
      organization_employee_address_type_id: "",
      address_line1: "",
      address_line2: "",
      address_line3: "",
      general_city_id: "",
      postal_code: "",
      organization_employee_residential_ownership_type_id: "",
      employee_id: "",
      organization_id: "",
    },
  ],
  Contact: [
    {
      employee_id: "",
      personal_phone_number: "",
      alternate_personal_phone_number: "",
      personal_email: "",
      alternate_personal_email: "",
      preferred_contact_method: "",
      emergency_person_phone_number_1: "",
      emergency_person_name_1: "",
      emergency_person_relation_1: "",
      emergency_person_phone_number_2: "",
      emergency_person_name_2: "",
      emergency_person_relation_2: "",
      work_phone_number: "",
      work_email: "",
      organization_id: "",
    },
  ],
  Experience: [
    {
      employee_id: "",
      organization_name: "",
      job_title: "",
      employment_type: "",
      internship_compensation_type: "",
      general_industry_id: "",
      start_date: "",
      end_date: "",
      is_current_job: "",
      last_drawn_ctc: "",
      currency_code: "",
      location: "",
      reporting_manager_name: "",
      reporting_manager_contact: "",
      description: "",
      is_verified: false,
      verified_by: "",
      verification_date: "",
      verification_notes: "",
      organization_id: "",
    },
  ],
  Medical: [
    {
      employee_id: "",
      blood_group: "",
      allergies: "",
      diseases: "",
      disability_status: "",
      disability_description: "",
      is_fit_for_duty: "",
      last_health_check_date: "",
      medical_notes: "",
      organization_id: "",
    },
  ],
  PaymentMethod: [
    {
      organization_id: "",
      employee_id: "",
      account_holder_name: "",
      bank_name: "",
      ifsc_code: "",
      account_number: "",
      account_type: false,
      is_primary: false,
      qr_code_url: "",
      remarks: "",
    },
  ],

  resetData: () => {
    set({
      Employee: {
        employee_code: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        date_of_birth: "",
        employee_id: "",
        organization_id: "",
        gender: "",
        marital_status: "",
        disability_flag: 0,
        profile_image_url: "",
        organization_unit_id: "",
        organization_employment_type_id: "",
        organization_department_id: "",
        organization_designation_id: "",
        organization_employment_type_id: "",
        organization_work_model_id: "",
        organization_work_shift_id: "",
        organization_employment_status_id: "",
        organization_user_id: "",
        date_of_joining: "",
        organization_user_id: "",
        reporting_manager_id: "",
      },
      EmployeeErrors: {},

      Education: [
        {
          organization_education_level_id: "",
          organization_education_degree_id: "",
          organization_education_stream_id: "",
          institute_name: "",
          board_university_name: "",
          marks_percentage: "",
          year_of_passing: "",
          is_pursuing: "",
          employee_id: "",
          organization_id: "",
        },
      ],
      EducationErrors: {},

      Language: [
        {
          employee_id: "",
          language_id: "",
          can_read: false,
          can_write: false,
          can_speak: false,
          is_native: false,
          description: "",
          organization_id: "",
        },
      ],
      Family: [
        {
          employee_id: "",
          name: "",
          relationship: "",
          phone: "",
          date_of_birth: "",
          is_dependent: "",
          organization_id: "",
        },
      ],
      Address: [
        {
          organization_employee_address_type_id: "",
          address_line1: "",
          address_line2: "",
          address_line3: "",
          general_city_id: "",
          postal_code: "",
          organization_employee_residential_ownership_type_id: "",
          employee_id: "",
          organization_id: "",
        },
      ],
      Contact: [
        {
          employee_id: "",
          personal_phone_number: "",
          alternate_personal_phone_number: "",
          personal_email: "",
          alternate_personal_email: "",
          preferred_contact_method: "",
          emergency_person_phone_number_1: "",
          emergency_person_name_1: "",
          emergency_person_relation_1: "",
          emergency_person_phone_number_2: "",
          emergency_person_name_2: "",
          emergency_person_relation_2: "",
          work_phone_number: "",
          work_email: "",
          organization_id: "",
        },
      ],
      Experience: [
        {
          employee_id: "",
          organization_name: "",
          job_title: "",
          employment_type: "",
          internship_compensation_type: "",
          general_industry_id: "",
          start_date: "",
          end_date: "",
          is_current_job: "",
          last_drawn_ctc: "",
          currency_code: "",
          location: "",
          reporting_manager_name: "",
          reporting_manager_contact: "",
          description: "",
          is_verified: false,
          verified_by: "",
          verification_date: "",
          verification_notes: "",
          organization_id: "",
        },
      ],
      Medical: [
        {
          employee_id: "",
          blood_group: "",
          allergies: "",
          diseases: "",
          disability_status: "",
          disability_description: "",
          is_fit_for_duty: "",
          last_health_check_date: "",
          medical_notes: "",
          organization_id: "",
        },
      ],
      PaymentMethod: [
        {
          organization_id: "",
          employee_id: "",
          account_holder_name: "",
          bank_name: "",
          ifsc_code: "",
          account_number: "",
          account_type: false,
          is_primary: false,
          qr_code_url: "",
          remarks: "",
        },
      ],
    });
  },

  setLanguageData: (name, value, id) => {
    let { Language } = get();

    Language[id] = { ...Language[id], [name]: value };
    set(Language);
  },

  setFamilyData: (name, value, id) => {
    let { Family } = get();

    Family[id] = { ...Family[id], [name]: value };
    set(Family);
  },

  setAddressData: (name, value, id) => {
    const { Address, AddressErrors } = get();
    const updatedAddress = [...Address];
    updatedAddress[id] = { ...updatedAddress[id], [name]: value };

    const updatedErrors = { ...AddressErrors };
    if (updatedErrors[id]?.[name]) {
      delete updatedErrors[id][name];
      if (Object.keys(updatedErrors[id]).length === 0) {
        delete updatedErrors[id];
      }
    }

    set({ Address: updatedAddress, AddressErrors: updatedErrors });
  },

  setContactData: (name, value, id) => {
    const { Contact, ContactErrors } = get();
    const updatedContact = [...Contact];
    updatedContact[id] = { ...updatedContact[id], [name]: value };

    const updatedErrors = { ...ContactErrors };
    if (updatedErrors[id]?.[name]) {
      delete updatedErrors[id][name];
      if (Object.keys(updatedErrors[id]).length === 0) {
        delete updatedErrors[id];
      }
    }

    set({ Contact: updatedContact, ContactErrors: updatedErrors });
  },

  setExperienceData: (name, value, id) => {
    let { Experience } = get();

    Experience[id] = { ...Experience[id], [name]: value };
    set(Experience);
  },

  setMedicalData: (name, value, id) => {
    let { Medical } = get();

    Medical[id] = { ...Medical[id], [name]: value };
    set(Medical);
  },
  setPaymentMethodData: (name, value, id) => {
    let { PaymentMethod } = get();

    PaymentMethod[id] = { ...PaymentMethod[id], [name]: value };
    set(PaymentMethod);
  },

  DropDownData: {
    departments: [],
    Units: [],
    EmploymentTypes: [],
    WorkModels: [],
    designations: [],
    WorkShifts: [],
    EmploymentStatus: [],
    Employees: [],
    languages: [],
  },

  getDropdowndata: async (orgId) => {
    let { DropDownData } = get();

    const token = localStorage.getItem("token");

    axios
      .get(`${MAIN_URL}/api/organizations/${orgId}/department`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const raw = response.data?.Departments;
        const departments = Array.isArray(raw)
          ? raw
          : raw?.data || response.data?.data || [];
        set((state) => ({
          DropDownData: {
            ...state.DropDownData,
            departments,
          },
        }));
      });

    axios
      .get(`${MAIN_URL}/api/organizations/${orgId}/units`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        set((state) => ({
          DropDownData: { ...state.DropDownData, Units: response.data?.Unit?.data || [] },
        }));
      });

    axios
      .get(`${MAIN_URL}/api/organizations/${orgId}/work-model`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        set((state) => ({
          DropDownData: {
            ...state.DropDownData,
            WorkModels: response.data?.workmodel?.data || [],
          },
        }));
      });

    axios
      .get(`${MAIN_URL}/api/organizations/${orgId}/workshift`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const raw = response.data?.workshifts;
        const workShifts = Array.isArray(raw)
          ? raw
          : raw?.data || [];
        set((state) => ({
          DropDownData: {
            ...state.DropDownData,
            WorkShifts: workShifts,
          },
        }));
      });

    axios
      .get(`${MAIN_URL}/api/organizations/${orgId}/designation`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        set((state) => ({
          DropDownData: {
            ...state.DropDownData,
            designations: response.data?.organizationdesignation?.data || [],
          },
        }));
      });

    axios
      .get(`${MAIN_URL}/api/organizations/${orgId}/employment-status`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const raw = response.data?.status;
        const employmentStatus = Array.isArray(raw)
          ? raw
          : raw?.data || [];
        set((state) => ({
          DropDownData: {
            ...state.DropDownData,
            EmploymentStatus: employmentStatus,
          },
        }));
      });

    // Note: Employees should be fetched with person_type_id parameter
    // This function now requires person_type_id to be passed separately
    // For backward compatibility, if person_type_id is not provided, it will fetch all
    // The actual fetching should be done in components with person_type_id selection

    axios
      .get(`${MAIN_URL}/api/organizations/${orgId}/employemnt-type`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        set((state) => ({
          DropDownData: {
            ...state.DropDownData,
            EmploymentTypes: response.data?.employemtType?.data || [],
          },
        }));
      });

    axios
      .get(`${MAIN_URL}/api/organizations/${orgId}/language`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        set((state) => ({
          DropDownData: {
            ...state.DropDownData,
            languages: response.data?.Languages?.data || [],
          },
        }));
      });
  },
}));

export default useEmployeeDataStore;
